<template>
  <div>
    <header-bar/>
    <div class="row">
      <div class="menu-sidebar" v-if="isLogin">
        <menu-sidebar />
      </div>
      <div class="content margin-top" :class="{ 'login-background': $route.path == '/login' }">
        <div class="container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from "./components/Layout/HeaderBar";
import MenuSidebar from "./components/Layout/MenuSidebar";
import { mapState } from "vuex";
export default {
  name: "MainLayout",
  components: { MenuSidebar, HeaderBar },
  data() {
    return {
      style: "background-color : #ffffff"
    };
  },
  created() {
    // if (this.isLogin) {
    //   console.log('this.isLogin',this.isLogin)
    //   this.$router.push('/home');
    //   this.$store.dispatch('Login/onGetUserDetail',this.token)
    // } else {
    //   console.log('result',this.$route)
    //   if (this.$route.query.hasOwnProperty('result')) {
    //   //
    //   //   console.log('result')
    //   } else {
    //   //   this.$store.dispatch("Login/clearLogin");
    //   //   this.$router.push("/login");
    //   }
    // }
  },
  computed: {
    ...mapState({
      isLogin: state => {
        return state.Login.isLogin;
      },
      token: state => {
        return state.Login.token;
      }
    })
  },
  mounted() {
    console.log('mounted app')
    if (this.isLogin) {
        console.log('this.isLogin',this.isLogin)
        this.$store.dispatch('Login/onGetUserDetail',this.token)
      }
  },
};
</script>
<style lang="scss">
@import "./assets/css/variables.scss";
@import "/assets/css/table.css";
@import "/assets/css/switch.css";

.pencil {
  color: $submit-color;
  font-size: 20px;
}
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.switch-app {
  float: right !important;
  height: 50px !important;
  background: transparent !important;
}
.v-application .primary--text {
  color: $submit-color !important;
  caret-color: $submit-color !important;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
<style lang="scss" scoped>
@import "assets/css/variables";
.margin-top {
  margin-top: 70px;
}
.menu-sidebar {
  margin-top: 60px;
  width: 20%;
}
.content {
  background-color: $background-theme;
  width: 80%;
}
.login-background {
  background-color: white;
  width: 100%;
}

@media screen and (max-width: 800px) {
  .menu-sidebar {
    width: 100%;
    margin-top: 60px;
  }
  .content {
    background-color: $background-theme;
    width: 100%;
  }
}
</style>
